jQuery(document).ready(function ($) {
if (typeof InstagramToken !== 'undefined') {
  let feed = new Instafeed({
    accessToken: InstagramToken,
    //accessToken: '3672948962.0f64772.430edb7f711e4665b59777c54d1ed9ce',
    //template: '<div class="slide"> <div class="content box-img1"> <a href="{{ link }}" class="delay03 inline-block" target="_blank"><img src="{{ image }}" class="img-fluid">  </div> </a></div>',
    template: '<div class="slide"><a href="{{ link }}" class="delay03 inline-block instafeed-image-wrapper adaptive-img-wrapper" target="_blank"><img src="{{ image }}" alt="Instagram" class="lazyload absolute-img"></a></div>',
    target: 'instagram-feed',
    resolution: 'standard_resolution',
    after: instagramFeed2,
    success: function (res) {
      console.log(res)
    }
  });

  feed.run();
}
  
  function instagramFeed2() {
    $('.list-instagram').slick({
      cssEase: 'cubic-bezier(1, 0.19, 0.25, 1)',
      arrows: true,
      dots: false,
      infinite: true,
      autoplay: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-brand-prev" aria-label="Previous slide"><svg width="15" height="26" viewBox="0 0 15 26" xmlns="http://www.w3.org/2000/svg"><path d="M-.06 12.646L12.645-.06l1.415 1.415L2.769 12.646 14.06 23.94l-1.415 1.415z" fill="#000" fill-rule="nonzero"/></svg></button>',
      nextArrow: '<button type="button" class="slick-brand-next" aria-label="Next slide"><svg width="15" height="26" viewBox="0 0 15 26" xmlns="http://www.w3.org/2000/svg"><path d="M15.06 12.646L2.355 25.354.939 23.939l11.292-11.293L.94 1.354 2.354-.061z" fill="#000" fill-rule="nonzero"/></svg></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
});